import { call, put, takeLatest } from 'redux-saga/effects';
import { postedNoteService } from './postedNote.service';
import {
    CREATE_POSTED_NOTE,
    DELETE_POSTED_NOTE,
    EDIT_POSTED_NOTE,
    GET_POSTED_NOTE,
    GET_POSTED_NOTE_SUCCESS,
} from './postedNote.types';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

function* getPostedNote(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(postedNoteService.getPostedNoteService, action.payload.clientId);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({ type: GET_POSTED_NOTE_SUCCESS, payload: res.data || null });
    } catch (err) {
        // A missing note isn't a UI error state — treat failures as "no note".
        yield put({ type: GET_POSTED_NOTE_SUCCESS, payload: null });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* upsertPostedNote(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(postedNoteService.updatePostedNoteService, action.payload.clientId, action.payload.body);
        yield put({ type: GET_POSTED_NOTE_SUCCESS, payload: res.data || null });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deletePostedNote(action) {
    // Clearing the note is a PATCH with empty content.
    yield* upsertPostedNote({ type: action.type, payload: { clientId: action.payload.clientId, body: { content: '' } } });
}

export const watchPostedNote = function* watchPostedNoteSaga() {
    yield takeLatest(GET_POSTED_NOTE, getPostedNote);
    yield takeLatest(CREATE_POSTED_NOTE, upsertPostedNote);
    yield takeLatest(EDIT_POSTED_NOTE, upsertPostedNote);
    yield takeLatest(DELETE_POSTED_NOTE, deletePostedNote);
};
